import React, { Suspense, useEffect, useState } from 'react';

import { useTabs } from '../../../../hooks/useTabs';
import { Layout } from '../../../Layout';
import { Loader } from '../../../Loader';
import { Menu } from '../Menu';
import { Select } from '../Select';
import { Content } from '../Content';

export const MainModal: React.FC = () => {
  const { tabs, error, loading } = useTabs();

  const [currentInstrument, selectInstrument] = useState(tabs[0]?.firstAvailable);

  useEffect(() => {
    !currentInstrument && selectInstrument(tabs[0]?.firstAvailable);
  }, [tabs, currentInstrument]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div>{error.message}</div>;
  }

  if (!tabs.length) {
    return <div>There is no available deposit instruments</div>;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Layout
        menu={<Menu selectInstrument={selectInstrument} currentInstrument={currentInstrument} />}
        select={<Select currentInstrument={currentInstrument} />}
        content={<Content currentInstrument={currentInstrument} />}
      />
    </Suspense>
  );
};
